module.exports = __webpack_public_path__ + "static/media/coding_minds.7ddce085.png";